export class MaintenanceTpre {
    public id: number;
    public codTpre: string;
    public descTpre: string;
    public onHold: boolean;

    public estado: boolean;
    public usrCreacion: string = "";
    public fecCreacion: Date = new Date();
    public usrModif: string | undefined;
    public fecModif: Date | undefined;
    public isSave: boolean;
    public isEdit: boolean;
    public isAdd: boolean;
    public originalData: MaintenanceTpre;


    static transformTpre(data: any): MaintenanceTpre {
        let tpre = new MaintenanceTpre();
        tpre.id = data.id;
        tpre.codTpre = data.codTpre;
        tpre.descTpre = data.descTpre;
        tpre.onHold = data.onHold;


        tpre.estado = data.estado;
        tpre.usrCreacion = data.usrCreacion;
        tpre.fecCreacion = new Date(data.fecCreacion);

        if (data.usrModif != undefined) {
            tpre.usrModif = data.usrModif;
            tpre.fecModif = new Date(data.fecModif);
        }

        return tpre;
      }


    }
